import React from 'react';

const GameCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white dark:bg-dark-800 rounded-lg shadow-md overflow-hidden animate-pulse">
      {/* Image skeleton */}
      <div className="w-full h-48 bg-gray-300 dark:bg-dark-700"></div>
      
      {/* Content skeleton */}
      <div className="p-4">
        {/* Title skeleton */}
        <div className="h-5 bg-gray-300 dark:bg-dark-700 rounded mb-2"></div>
        <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-3/4 mb-3"></div>
        
        {/* Description skeleton */}
        <div className="space-y-2 mb-4">
          <div className="h-3 bg-gray-300 dark:bg-dark-700 rounded"></div>
          <div className="h-3 bg-gray-300 dark:bg-dark-700 rounded w-5/6"></div>
        </div>
        
        {/* Tags skeleton */}
        <div className="flex gap-2 mb-4">
          <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded-full w-16"></div>
          <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded-full w-20"></div>
        </div>
        
        {/* Button skeleton */}
        <div className="h-10 bg-gray-300 dark:bg-dark-700 rounded"></div>
      </div>
    </div>
  );
};

export default GameCardSkeleton;

